







import { Component, Vue } from 'vue-property-decorator';
import ContentTop from '@/components/accumulation/ContentTop.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    ContentTop,
    PageTitle,
    AdminIframe,
  },
})
export default class AccumulationSettingIframe extends Vue {
  private get remoteSrc() {
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/accumulation/setting?serviceType=PREMIUM';
  }
}
